<template>
  <div class="reference-list">
    <div v-if="dataList && dataList.length">
      <div
        v-for="(item, index) in dataList"
        :key="index"
        class="reference-item"
        @click="toDetailPage(item.id)"
      >
        <div class="reference-card-detail">
          <div class="card-detail-title">
            {{ item.reportName }}
          </div>
          <div class="card-detail-selectTime">
            <span>选择时间：</span>
            <span>{{ item.selectTime.yearWeekNum.substring(4) }}({{ item.selectTime.weekBeginDateId }}~{{ item.selectTime.weekEndDateId }})</span>
          </div>
          <div class="card-detail-comptime">
            <span>对比时间：</span>
            <span>{{ item.compareTime.yearWeekNum.substring(4) }}({{ item.compareTime.weekBeginDateId }}~{{ item.compareTime.weekEndDateId }})</span>
          </div>
          <div class="card-detail-comptime">
            <span>创建时间：</span>
            <span>{{ item.createTime }}</span>
          </div>
        </div>
        <div class="reference-icon">
          <van-icon name="arrow" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  mapState,
} from 'vuex';
import Icon from 'vant/lib/icon';
import Button from 'vant/lib/button';
import Cell from 'vant/lib/cell';
import CellGroup from 'vant/lib/cell-group';
import MarketingApi from '@/api/marketing';

import 'vant/lib/icon/style';
import 'vant/lib/button/style';
import 'vant/lib/cell/style';
import 'vant/lib/cell-group/style';

export default {
  name: 'ReferenceInfoList',
  components: {
    [Button.name]: Button,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Icon.name]: Icon,
  },
  data() {
    return {
      dataList: [],
    };
  },
  computed: {
    ...mapState(['isAgent', 'poiList', 'accountType']),
    ...mapState('billModule', ['customerId']),
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      const { data } = await MarketingApi.getReferenceList(this.customerId);
      this.dataList = data && data.list;
    },
    toDetailPage(id) {
      this.$router.push(`/referenceinfo/detail?reportId=${id}`);
    },
  },
};
</script>
<style lang="scss" scoped>
.reference-list{
  background: #f7f7f7;
  padding-top: 20px;
  .reference-item{
    display: flex;
    background: #fff;
    margin: 0 20px 30px;
    padding: 30px 22px;
    border-radius: 20px;
    text-align: left;
  }
  .reference-icon{
    width: 60px;
    font-size: 40px;
    line-height: 170px;
    color: #999;
  }
  .reference-card-detail{
    flex: 1;
  }
  .card-detail-title{
    font-size: 28px;
    color:#444;
  }
  .card-detail-comptime,.card-detail-selectTime{
    color:#666;
    font-size: 24px;
    margin-top: 6px;
    span:last-child{
      font-size: 22px;
      color:#999;
    }
  }
}
</style>
